import _ from 'lodash'

//import { mapMutations } from 'vuex'

//import SETTINGS from '@/plugins/settings'

import Badge from '@/models/badge'
import Domain from '@/models/domain'
import Group from '@/models/group'
import Menu from '@/models/menu'
import Notification from '@/models/notification'
import User from '@/models/user'

const Utility = {

  computed:
  {
    /*
    appName()
    {
      return SETTINGS.APP_NAME
    },
    */

    isMobile()
    {
      return this.$vuetify.breakpoint.smAndDown
    },

    isSmartphone()
    {
      return this.$vuetify.breakpoint.xs
    },

    isTablet()
    {
      console.log(this.$vuetify.breakpoint)
    }
  },

  methods:
  {
    /*
    ...mapMutations({
      setBack: 'ui/setBack'
    }),
    */

    goTo(where)
    {
       if( typeof where == 'string' )
         where = { name:where }

       this.$router.push(where).catch(()=>{})
    },

    hideBack()
    {
      this.setBack(null)
    },

    mapModel(model, classToMap='user')
    {
      return this.mapModels([model], classToMap)[0]
    },

    mapModels(models=[], classToMap='user')
    {
      return _.map(models, (model)=>{

        switch( classToMap.toLowerCase() ){
          case 'badge': return new Badge(model)
          case 'domain': return new Domain(model)
          case 'group': return new Group(model)
          case 'menu': return new Menu(model)
          case 'notification': return new Notification(model)
          case 'user': return new User(model)
          default: return model
        }

      })
    },

    scrollTo(el) 
    {
      this.$vuetify.goTo( `#${el}`, { offset: 60 })
    },

    /*
    storageUrl(append="")
    {
      return `${SETTINGS.BACKEND_URL}storage/${append}`
    }
    */

  }
}

export default Utility